// MessageCard.jsx (no CSS import)
import { Alert, Box } from "@mui/material";

const toSeverity = (type) =>
  ["success", "error", "warning", "info"].includes(type) ? type : "info";

const MessageCard = ({ message, type = "info", onClose }) => {
  const displayMessage =
    typeof message === "string"
      ? message
      : message?.message || JSON.stringify(message || "");

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: (theme) => theme.zIndex.snackbar,
        maxWidth: 480,
      }}
    >
      <Alert
        severity={toSeverity(type)}
        onClose={onClose}
        variant="filled"
        sx={{
          gap: 1,
          borderRadius: 2,
          boxShadow: 3,
          whiteSpace: "pre-line",
          alignItems: "center",
          fontSize: "0.95rem",
        }}
      >
        {displayMessage}
      </Alert>
    </Box>
  );
};

export default MessageCard;
